/*
 * @copyright Internet Business Partner, all rights reserved (c) 2020
 * @author    Marek Lisiecki <m.lisiecki@ibp.net.pl>
 * @license   Commercial
 */

const textParser = input => {
    return input
        .replace(/\*\*(.*?)\*\*/gm, "<b>$1</b>")
        .replace(/__(.*?)__/gm, "<i>$1</i>")
        .replace(/^#{1} (.*?)$/gm, "<h1>$1</h1>")
        .replace(/^#{2} (.*?)$/gm, "<h2>$1</h2>")
        .replace(/^#{3} (.*?)$/gm, "<h3>$1</h3>")
        .replace(/^\* (.*?)$/gm, "<li>$1</li>")
        .replace(/\n+/gm, "\n")
        .replace(/^(.(?!<\/li>|<\/h1>|<\/h2>|<\/h3>))*$/gm, "<p>$&</p>")
};

export default textParser;